import { addDays, addHours, nextWednesday, subHours } from "date-fns"
import { useCountryCode } from "src/components/(checkout)/country/state"
import { AppCountryCode } from "src/localization/localization"
import { recordError } from "src/utilities/errorReporting"
import { getOffsetToGermanyHours } from "src/utilities/germanTime"

// https://www.dpd.com/de/de/support/international/#support_international_laufzeiten

const minShippingDays: Record<AppCountryCode, number> = {
  de: 1,
  at: 1,
}

const maxShippingDays: Record<AppCountryCode, number> = {
  de: 2,
  at: 2,
}

// 0 = Sunday, 6 = Saturday
const lastShippingWeekday = 6

// Parcels are handed over to DPD between 13:00 and 15:00
const fulfillmentUntilHour = 14

export function useMinShippingDays() {
  const countryCode = useCountryCode()

  const days = minShippingDays[countryCode]

  if (!days) {
    recordError(`No min shipping days configured for country code ${countryCode}`)
    return
  }

  return days
}

export function useMaxShippingDays() {
  const countryCode = useCountryCode()

  const days = maxShippingDays[countryCode]

  if (!days) {
    recordError(`No nax shipping days configured for country code ${countryCode}`)
    return
  }

  return days
}

export function calculateDailyFulfillmentDate(earliestFulfillmentDate = new Date()) {
  const hoursOffsetToGermany = getOffsetToGermanyHours()
  const timeInGermany = addHours(earliestFulfillmentDate, hoursOffsetToGermany)
  let fulfillmentDate = timeInGermany

  if (timeInGermany.getHours() >= fulfillmentUntilHour) {
    fulfillmentDate = addDays(fulfillmentDate, 1)
  }
  if (fulfillmentDate.getDay() === 6) {
    fulfillmentDate = addDays(fulfillmentDate, 1)
  }
  if (fulfillmentDate.getDay() === 0) {
    fulfillmentDate = addDays(fulfillmentDate, 1)
  }

  fulfillmentDate.setHours(fulfillmentUntilHour, 0, 0, 0)

  return subHours(fulfillmentDate, hoursOffsetToGermany)
}

export function calculateWeeklyFulfillmentDate(earliestFulfillmentDate = new Date()) {
  const hoursOffsetToGermany = getOffsetToGermanyHours()
  const timeInGermany = addHours(earliestFulfillmentDate, hoursOffsetToGermany)

  let fulfillmentDate = nextWednesday(timeInGermany)

  if (timeInGermany.getDay() === 2 && fulfillmentDate.getHours() >= 12) {
    fulfillmentDate = addDays(fulfillmentDate, 7)
  }

  fulfillmentDate.setHours(fulfillmentUntilHour, 0, 0, 0)

  return subHours(fulfillmentDate, hoursOffsetToGermany)
}

export function calculateShippingDate(fulfillmentDate: Date, shippingDays: number) {
  let daysToAdd = shippingDays

  if (fulfillmentDate.getDay() + daysToAdd > lastShippingWeekday) {
    daysToAdd += 7 - lastShippingWeekday
  }

  return addDays(fulfillmentDate, daysToAdd)
}
